var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-bordered table-responsive table-hover table-sm"},[_c('thead',[_c('tr',_vm._l((_vm.cols),function(col){return _c('th',[_vm._v(_vm._s(col))])}))]),_vm._v(" "),_c('tbody',_vm._l((_vm.rows),function(row){return _c('tr',_vm._l((_vm.cols),function(v,k){return _c('td',[_vm._v(_vm._s(row[k]))])}))}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6d24fc4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/table-edit.vue
// module id = 1621
// module chunks = 1